module.exports = __webpack_public_path__ + "img/icon_3.dca489a0.png";